import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FormBuilder} from '@angular/forms';
import {SUPPORTED_LANGUAGES, SupportedLanguage} from '../../models/supported-language.model';
import {MatSelectModule} from '@angular/material/select';
import {TranslateService} from '@ngx-translate/core';
import {AppState} from '../../store';
import {select, Store} from '@ngrx/store';
import {selectTranslatedLanguageNamesMap} from '../../store/selectors';
import {UrlBuilderService} from '../../services/url-builder.service';
import {MatOptionModule} from '@angular/material/core';
import {NgClass, NgFor} from '@angular/common';
import {MatFormFieldModule} from '@angular/material/form-field';

interface Language {
  code: SupportedLanguage;
  description: string;
}

export type LanguageDropdownTheme = "dark-mode" | "light-mode";


@Component({
    selector: 'language-dropdown',
    templateUrl: './language-dropdown.component.html',
    styleUrls: ['./language-dropdown.component.scss'],
    standalone: true,
    imports: [MatFormFieldModule, NgClass, MatSelectModule, NgFor, MatOptionModule]
})
export class LanguageDropdownComponent implements OnInit {

  @Input() language: SupportedLanguage = 'en';

  @Input() uiMode: LanguageDropdownTheme = "light-mode";

  supportedLanguages: Language[] = [];

  languageNamesMap: {[key:string]:string} = {};

  @Output() languageChanged = new EventEmitter();

  constructor(private fb: FormBuilder,
              private translate: TranslateService,
              private store: Store<AppState>,
              public ub: UrlBuilderService) {

  }

  ngOnInit() {

    this.store.pipe(select(selectTranslatedLanguageNamesMap))
      .subscribe(languageNamesMap => {

        this.languageNamesMap = languageNamesMap;

        this.supportedLanguages = SUPPORTED_LANGUAGES.map(lang => {
          return {
            code: lang,
            description: languageNamesMap[lang]
          }
        });

      });


  }

  onSelectionChange(event) {
    console.log(event.value);
    this.languageChanged.emit(event.value);
  }

  getFlagUrl(language: SupportedLanguage) {
    return this.ub.getFlagUrl(language);
  }

  isDarkMode() {
    return this.uiMode == 'dark-mode';
  }
}
